import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { SharedModule } from 'shared/shared.module';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { SearchPageService } from 'shared/search-page/search-page.service';

import { ExportManagerRoutingModule } from './export-manager-routing.module';
import { ExportManagerComponent } from './export-manager.component';
/* eslint-disable */
import { ExportManagerSearchResultsComponent } from './search/export-manager-search-results/export-manager-search-results.component';
import { ExportManagerSearchResultsRowComponent} from './search/export-manager-search-results-row/export-manager-search-results-row.component';
import { ExportScheduleManagerModalComponent } from './components/export-schedule-manager-modal/export-schedule-manager-modal.component';
import { ExportScheduleManagerSearchComponent } from './components/export-schedule-manager-search/export-schedule-manager-search.component';
/* eslint-enable */
import { ReceiversModalComponent } from './components/receivers-modal/receivers-modal.component';
import { ReceiversTableComponent } from './components/receivers-modal/receivers-table/receivers-table.component';
import { ReceiversTableRowComponent } from './components/receivers-modal/receivers-table/receivers-table-row/receivers-table-row.component';
import { ContextualActionModule } from './components/contextual-actions/contextual-action.module';
import { ExportScheduleManagerSearchService } from './components/export-schedule-manager-search/export-schedule-manager-search.service';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    SharedModule,
    ExportManagerRoutingModule,
    ContextualActionModule,
  ],
  declarations: [
    ExportManagerComponent,
    ExportManagerSearchResultsComponent,
    ExportManagerSearchResultsRowComponent,
    ReceiversModalComponent,
    ReceiversTableComponent,
    ReceiversTableRowComponent,
    ExportScheduleManagerModalComponent,
    ExportScheduleManagerSearchComponent,
  ],
  exports: [ExportManagerComponent],
  providers: [
    ScrollToService,
    SearchPageService,
    ExportScheduleManagerSearchService,
  ]
})
export class ExportManagerModule { }
